export default "__VITE_PUBLIC_ASSET__e190739f__"